import React from 'react';

interface PdfPreviewFallbackProps {
  pdfUrl: string;
  width?: number;
  height?: number;
}

/**
 * Fallback component for PDFPreview when the browser cannot parse modern JavaScript.
 * Displays a message with a link to download/view the PDF instead.
 */
const PdfPreviewFallback: React.FC<PdfPreviewFallbackProps> = ({ pdfUrl, width = 300, height = 400 }) => {
  return (
    <div 
      style={{ width, height }} 
      className="flex flex-col items-center justify-center border border-gray-300 rounded-lg bg-gray-50 p-4"
    >
      <div className="text-center">
        <p className="text-sm text-gray-600 mb-2">PDF preview not available</p>
        <p className="text-xs text-gray-500 mb-4">Your browser version does not support PDF rendering.</p>
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 underline text-sm"
        >
          Open PDF in new tab
        </a>
      </div>
    </div>
  );
};

export default PdfPreviewFallback;

